var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatPumpConsumption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.986816,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#758EA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9444 12.9868H14.0556C13.2 12.9868 12.5 13.6868 12.5 14.5424V25.4313C12.5 26.2868 13.2 26.9868 14.0556 26.9868H24.9444C25.8 26.9868 26.5 26.2868 26.5 25.4313V14.5424C26.5 13.6868 25.8 12.9868 24.9444 12.9868ZM20.0833 16.1601C20.7211 16.2535 21.3044 16.4868 21.7944 16.8757L20.0833 18.579V16.1601ZM18.9167 16.1601V18.579L17.2056 16.8757C17.6956 16.4868 18.2789 16.2535 18.9167 16.1601ZM16.3889 17.6924L18.0922 19.4035H15.6733C15.7667 18.7657 16 18.1824 16.3889 17.6924ZM15.6733 20.5701H18.0922L16.3889 22.2813C16 21.7913 15.7667 21.2079 15.6733 20.5701ZM18.9167 23.8135C18.2789 23.7201 17.6956 23.4868 17.2056 23.0979L18.9167 21.3946V23.8135ZM19.5 20.7646C19.0722 20.7646 18.7222 20.4146 18.7222 19.9868C18.7222 19.559 19.0722 19.209 19.5 19.209C19.9278 19.209 20.2778 19.559 20.2778 19.9868C20.2778 20.4146 19.9278 20.7646 19.5 20.7646ZM20.0833 23.8135V21.3946L21.7944 23.0979C21.3044 23.4868 20.7211 23.7201 20.0833 23.8135ZM22.6111 22.2813L20.9078 20.5701H23.3267C23.2333 21.2079 23 21.7913 22.6111 22.2813ZM20.9078 19.4035L22.6111 17.6924C23 18.1901 23.2333 18.7735 23.3267 19.4035H20.9078Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatPumpConsumption);
export default __webpack_public_path__ + "static/media/heat-pump-consumption.bb3ec5c928f39368b68c4c444df0673b.svg";
export { ForwardRef as ReactComponent };